import { render, staticRenderFns } from "./InformantDetails.vue?vue&type=template&id=87c5b118"
import script from "./InformantDetails.vue?vue&type=script&lang=js"
export * from "./InformantDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports